
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Dyslexia(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Dyslexia"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>Dyslexia is a <b>learning disorder</b> that involves difficulty reading due to
                                    problems identifying speech sounds and learning how they relate to
                                    letters and words (decoding). Also called reading disability, dyslexia
                                    affects areas of the brain that process language.</p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/Dyslexia/1.png")} alt="Dyslexia" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>Late talking</p>
                                <p>Learning new words slowly</p>
                                <p>Problems forming words correctly, such as reversing sounds in words or confusing words that
                                    sound alike</p>
                                <p>Problems remembering or naming letters, numbers and colors</p>
                                <p>Difficulty learning nursery rhymes or playing rhyming games</p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Dyslexia">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Dyslexia;